import { Component, OnInit } from '@angular/core';
import { GipReqReplotForm, GipRequestDnloadForm } from '../gipRequestDnloadFormModel';
import { ActivatedRoute, Router } from '@angular/router';
import { SharingDataService } from 'src/app/Services/sharing-data.service'
import { CommonService } from 'src/app/Services/common.service';
import { DownloadService } from '../download.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { GridConfig } from 'src/app/template/gridTemplate/gridConfig';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'appGipReqDnloadForm',
  templateUrl: './gipReqDnloadForm.component.html',
  styleUrls: ['./gipReqDnloadForm.component.css']
})
export class GipReqDnloadFormComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private commonService: CommonService,
    private router: Router,
    private downloadService: DownloadService,
    private shareData: SharingDataService,
    private errorHandlingService: ErrorHandlingService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe) { }


  g3e_fid: string;
  isEdit: boolean;
  urlBase = "data/MS_REQ_N";
  modelInput = GipRequestDnloadForm;
  replotModel = GipReqReplotForm;
  resourceDefinition: any;
  gridMetadataUrl = `data/V_MS_REQDOC_DL`;
  defaultFilter: string;
  groupName = "DOWNLOAD"

  formular = [
    { formControlName: "G3E_ID", hidden: true, readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "G3E_FID", hidden: false, readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "PERSON_ID", hidden: true, readonly: false, editReadonly: false, newReadonly: false, inputString: true },
    { formControlName: "CONTRACT_ID", hidden: true, readonly: false, editReadonly: false, newReadonly: false, inputString: true },
    { formControlName: "C_PERSON_ID", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "DELIVERY_STATE", hidden: true, readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "C_DELIVERY_STATE", readonly: true, editReadonly: true, newReadonly: true, picklist: "V_MS_DELIVERY_STATE_VL_T" },
    { formControlName: "REQUEST_STATE", hidden: true, readonly: false, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "C_REQUEST_STATE", inputString: true, readonly: true, editReadonly: true, newReadonly: true, picklist: "V_MS_REQUEST_STATE_VL_T" },
    { formControlName: "ACTIVITY_TYPE", hidden: true, inputString: true, readonly: true, editReadonly: true, newReadonly: true },
    { formControlName: "C_ACTIVITY_TYPE", readonly: true, inputString: true, editReadonly: true, newReadonly: true, picklist: "V_MS_ACTIVITY_TYPE_VL_T" },
    { formControlName: "REASON_TYPE", hidden: true, inputString: true, readonly: true, editReadonly: true, newReadonly: true },
    { formControlName: "C_REASON_TYPE", readonly: true, editReadonly: true, newReadonly: true, picklist: "V_MS_REASON_TYPE_VL_T" },
    { formControlName: "BEGIN_ACTIVITY_DT", readonly: true, editReadonly: true, newReadonly: true, datepicker: true, datepickerType: "beginActivityDt" },
    { formControlName: "END_ACTIVITY_DT", readonly: true, editReadonly: true, newReadonly: true, datepicker: true, datepickerType: "endActivityDt" },
    { formControlName: "REQUEST_DT", readonly: true, editReadonly: true, newReadonly: true, datepicker: true, datepickerType: "requestDt" },
    { formControlName: "EXPIRATION_DT", readonly: true, editReadonly: true, newReadonly: true, datepicker: true, datepickerType: "expirationDt" },
    { formControlName: "RESPONSIBLE_PERSON", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "RESPONSIBLE_PERSON_TEL_NUM", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "PERSON_EMAIL", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "LOCATION_DESC", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "LOCATION", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "COMPANY", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "C_REQUESTOR", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
  ];

  grid = [
    { name: "G3E_ID", visible: false, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "MAPSHEET_NUM", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "download", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "USERNAME", function: "download", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "DOWNLOAD_DT", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "date", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "download", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },

  ];

  config: GridConfig = new GridConfig();

  ngOnInit(): void {
    this.modelInput.reset();
    
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
    var hash = this.route?.snapshot?.params?.hash;
    if (hash != undefined)
      this.getHashParam(hash);
    else {
      this.getParams();

      if (this.g3e_fid != undefined) {
        this.defaultFilter = `G3E_FID eq '${this.g3e_fid}'`;
        this.getData(this.g3e_fid);
      }

    }
  }

  action(parameters) {
    this[parameters.action](parameters.element, parameters.column);
  }

  getHashParam(hash: string) {
    var urls = [`portal/gethashdata?hash=${hash}`];

    this.downloadService.getNonOData(urls, (data) => {

      var fid = data[0].data;
      this.g3e_fid = fid;

      this.defaultFilter = `G3E_FID eq ${this.g3e_fid}`;
      this.getData(this.g3e_fid);

    });
  }

  getParams(){
    if(this.replotModel.value.G3E_FID != undefined){
      this.g3e_fid = this.replotModel.value.G3E_FID;
      this.setReadonly();
    }
     else this.changeToNew();
  }

  getUrlParams() {
    this.route.queryParams
      .subscribe(params => {
        if (params.g3e_fid != undefined) {
          this.g3e_fid = params.g3e_fid;
          this.setReadonly();
        } else this.changeToNew();

        if (params.isEdit != undefined) {
          this.isEdit = params.isEdit;
          this.setReadonly();
        }
      });
  }

  setReadonly() {
    if (!this.isEdit && this.isEdit == undefined) {
      this.changeToDisplay();
    } else if (this.isEdit) {
      this.changeToEdit();
    }
  }


  changeToEdit() {
    this.formular.forEach(element => {
      if (element.editReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  changeToDisplay() {
    this.formular.forEach(element => {
      element.readonly = true;
    });
  }

  changeToNew() {
    this.formular.forEach(element => {
      if (element.newReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  getData(id: string) {
    let urls = [
      `${this.urlBase}?$filter=G3E_FID eq ${this.g3e_fid}`,
    ];
    var data = this.downloadService.getData(urls, (data) => {
      if (data[0][0] != undefined) {
        for (var dataElement in data[0][0]) {
          for (var element in this.modelInput.value) {
            if (dataElement == element) {
              this.modelInput.controls[element].setValue(data[0][0][dataElement])
            }
          }
        }
        this.modelInput.controls.C_DELIVERY_STATE.setValue(data[0][0].DELIVERY_STATE);
        this.modelInput.controls.C_REQUEST_STATE.setValue(data[0][0].REQUEST_STATE);
        this.modelInput.controls.C_ACTIVITY_TYPE.setValue(data[0][0].ACTIVITY_TYPE);
        this.modelInput.controls.C_REASON_TYPE.setValue(data[0][0].REASON_TYPE);

        let requestorURL = [`admin/MS_USER?$filter=USERGUID eq '${data[0][0].REQUESTOR}'`,];
        var requestorData = this.downloadService.getData(requestorURL, (data) => {
          if (data[0][0] != undefined) {
            this.modelInput.controls.C_REQUESTOR.setValue(data[0][0].FULLNAME);
          }
        });

      }
      let userUrl = [`admin/MS_USER?$filter=USERGUID eq '${this.modelInput.value.PERSON_ID}'`,];
      var userData = this.downloadService.getData(userUrl, (data) => {
        if (data[0][0] != undefined) {
          this.modelInput.controls['C_PERSON_ID'].setValue(data[0][0].FULLNAME);
        }
      });

    });
  }

  download(element) {
    this.downloadService.downloadFile(this.commonService.getGipServicesUrl() + 'file/ReqDocFileTest/' + element.G3E_ID, (result) => {
      if(result.type == "application/pdf"){
        var url = URL.createObjectURL(result); 
        window.open(url,'_blank');
      } else {
        FileSaver.saveAs(result,  element.USERNAME);
        this.config.methods.refresh();
      }
    }, (err) => {
      if (err.status == 400)
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('ServiceFileDispErr', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common"), undefined)
      else if(err.status < 200 || err.status > 206)
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('PortalTechnicalFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined)
    });
  }

  btnBackAction() {
    this.router.navigate(['/gipDnloadList']);
  }

  btnReplotAction() {
    this.router.navigate(['/gipReqReplot']);
  }

  btnNewreqAction() {
    this.router.navigate(['/newRequest']);
  }
}